import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import {
  AuthCoreService,
  ICompany,
  ICompanyUser,
} from '../core/auth-core/auth-core.service';
import { ApiV1Service } from '../core/api/apiv1.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
})
export class HomeComponent implements OnInit {
  constructor(
    private _authCoreService: AuthCoreService,
    private _router: Router,
    private _apiV1: ApiV1Service,
  ) {}
  image =  ''
  isCorteva = localStorage['auth']
    ? JSON.parse(localStorage['auth']).companyUser.company._id === '684a3ce1db4f66991573f720'
    : null;
  logout() {
    this._authCoreService.logout();
  }
  ngOnInit(): void {
    this.getUserAndCompanyDetail();
    console.log(this.constructor.name);
  }

  public getUserAndCompanyDetail() {
    return this._authCoreService.getUserAndCompanyDetail().subscribe((data: ICompanyUser) => {
      this.downloadImg(data);
    });
  }

  downloadImg(user: ICompanyUser) {
    if (user.company.company_logo !== '') {
      this._apiV1
        .get('/api/company/fileDownload/' + user?.company?.company_logo, {})
        .subscribe((ImgData:any) => {
          this.image = ImgData?.image
        });
    }
  }

  navigateToSettings() {
    this._router.navigate(['/settings'], {
      queryParams: { view: 'collaborators' },
    });
  }
}
